var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.119,
    height: 37.119,
    viewBox: "0 0 37.119 37.119",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#b6b6b6;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.56,0a18.56,18.56,0,1,0,18.56,18.56A18.562,18.562,0,0,0,18.56,0Zm.393,29.366h0a11.1,11.1,0,0,1-5.309-1.352L7.751,29.558,9.327,23.8a11.109,11.109,0,1,1,9.626,5.562Zm0,0",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M143.308,124.469a9.234,9.234,0,0,0-7.825,14.141l.219.349-.933,3.406,3.494-.916.337.2a9.218,9.218,0,0,0,4.7,1.287h0a9.233,9.233,0,0,0,0-18.466Zm5.431,13.2a2.86,2.86,0,0,1-1.873,1.319,3.81,3.81,0,0,1-1.748-.11,16.035,16.035,0,0,1-1.583-.585,12.371,12.371,0,0,1-4.741-4.19,5.4,5.4,0,0,1-1.133-2.87,3.111,3.111,0,0,1,.971-2.315,1.02,1.02,0,0,1,.74-.347c.185,0,.37,0,.532.01s.4-.065.624.476.786,1.921.856,2.06a.512.512,0,0,1,.023.486,7.914,7.914,0,0,1-.694.949c-.123.153-.284.289-.122.566a8.366,8.366,0,0,0,1.544,1.922,7.587,7.587,0,0,0,2.232,1.377c.277.139.439.116.6-.069s.694-.81.879-1.088.37-.231.624-.139,1.619.764,1.9.9.462.208.532.324a2.315,2.315,0,0,1-.162,1.319Zm0,0",
    transform: "translate(-124.351 -115.445)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.c8a272aad0b278292c71cdb62e193a2b.svg";
export { ForwardRef as ReactComponent };